import { Box, Button } from '@mui/material';
import React from 'react';
import { maskedAccountId } from "../common/Utils";
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import '../Reports/Reports.css';

export const CustomExcelExport = ({data, headers, filename, carefacility, type, reportType, method}) =>{   
    const processData = (data, headers) =>{
        const headerLabels = headers.map(header=>header.label).join(',');
        const rows = data.map(row=>
            headers.map(header=>{
                if(header.key ==="careFacilityName"){
                    return carefacility.careFacilityName;
                }
                if(header.key !=="careFacilityName"){
                    return row[header.key];
            }
            }).join(',')
        )
        return [headerLabels, ...rows].join('\n');
    };


    const filterData =(data, headers)=>{
        return data.map((row)=>{
            const filteredRow={};
            headers.forEach(col=>{
                if(row.hasOwnProperty(col.key)){
                    if(col.key === "accountNumber"){
                        filteredRow[col.key] = maskedAccountId(row[col.key]);
                    }
                    if(col.key ==="careFacilityName"){
                        filteredRow[col.key]= carefacility && Object.keys(carefacility).length>0 ?  carefacility.careFacilityName : row[col.key];
                    }
                    else {
                        filteredRow[col.key] = row[col.key]
                    }
                }
            });
            return filteredRow;
        })
    }

    const exportToExcel= async () =>{
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1') ;
        worksheet.columns = headers;
        const filteredData = filterData(data, headers);

        filteredData.forEach((item)=>{
         worksheet.addRow(item);
        });
 
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(blob, filename);
    }

    return (
        <>
        {type === "align-left" ? 
        <Box
        display="flex"
        flexDirection="row"
        sx={{ width: "350px" }}
      >
        <Button className="resident-new-btn" variant="contained" onClick={exportToExcel}>
            Download
        </Button>
        </Box>
        : null}

        {type !== "align-left" && reportType !=="audit_report" ?
        <Box
        display="flex"
        flexDirection="row"
        sx={{ width: "350px", justifyContent: "right", textAlign:"right", float:"right" }}
      >
        <Button className="resident-new-btn" variant="contained" onClick={exportToExcel}>
            Download
        </Button>
        </Box>
        : null}

        { reportType ==="audit_report" ? 
        <Button 
        sx={{
            backgroundColor:" #002d82 !important",
            borderRadius: "5px",
            textTransform: "unset !important",
            color: "#fff",
            marginBottom: "5px",
            align:"left",
            width: "140px"
        }}
        variant="contained" onClick={exportToExcel}>
         DOWNLOAD
        </Button> 
        : null}
        </>
    )
}